import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${
      queryFilter.sort
    },${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/atendimento/odontograma_status${queryUrl}`)
  },
  insertNew(data) {
    return axios.post('/atendimento/odontograma_status', data)
  },
  edit(data) {
    return axios.put(`/atendimento/odontograma_status/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/atendimento/odontograma_status/${id}`)
  },
}
